export default __webpack_public_path__ + "static/media/smartsheet-long.8ac36849.svg";